import { useMutation, useQueryClient } from "@tanstack/react-query";
import { QUERY_SETTINGS, saveSettings } from "api/landlord/landlord";
import { toast } from "react-toastify";
import { Button, ButtonVariant, Modal, Radio } from "shared/components";
import { getErrorMessage } from "utils/error";
import { SyncOption, SyncOptionLabels } from "../../constants";
import { FC } from "react";

type Props = {
  opened: boolean;
  onClose: () => void;
  syncOption: SyncOption;
  setSyncOption: (syncOption: string) => void;
};

export const SyncEditModal: FC<Props> = ({
  opened,
  onClose,
  syncOption,
  setSyncOption
}) => {
  const queryClient = useQueryClient();
  const { mutate: updateSyncStatus, isPending } = useMutation({
    mutationFn: saveSettings,
    onSuccess: () => {
      onClose();
      queryClient.invalidateQueries({ queryKey: [QUERY_SETTINGS] });
    },
    onError: (err) => {
      toast.error("Error saving integration details: " + getErrorMessage(err));
    }
  });

  return (
    <Modal opened={opened} onClose={onClose} panelClassName="w-[480px] p-6">
      <h3 className="text-xl font-bold text-content-1000 mb-2">
        Sync AppFolio &quot;Posted to your website&quot; status
      </h3>
      <p className="text-base text-content-500 mb-6">
        Sync AppFolio &quot;Posted to your website&quot; status with the ability
        to submit applications for the unit in Boom
      </p>
      <Radio
        onChange={() => {
          setSyncOption(SyncOption.NEVER);
        }}
        className="!gap-0 mb-2"
        labelClassName="text-content-500"
        id="sync_option"
        name={SyncOptionLabels[SyncOption.NEVER]}
        label={SyncOptionLabels[SyncOption.NEVER]}
        checked={syncOption === SyncOption.NEVER}
      />
      <Radio
        onChange={() => {
          setSyncOption(SyncOption.FIRST_SYNC);
        }}
        className="!gap-0 mb-2"
        labelClassName="text-content-500"
        id="sync_option"
        name={SyncOptionLabels[SyncOption.FIRST_SYNC]}
        label={SyncOptionLabels[SyncOption.FIRST_SYNC]}
        checked={syncOption === SyncOption.FIRST_SYNC}
      />
      <Radio
        onChange={() => {
          setSyncOption(SyncOption.EVERY_SYNC);
        }}
        className="!gap-0 mb-4"
        labelClassName="text-content-500"
        id="sync_option"
        name={SyncOptionLabels[SyncOption.EVERY_SYNC]}
        label={SyncOptionLabels[SyncOption.EVERY_SYNC]}
        checked={syncOption === SyncOption.EVERY_SYNC}
      />
      <div className="flex justify-end">
        <Button
          variant={ButtonVariant.PRIMARY}
          className="w-[125px]"
          onClick={() => {
            updateSyncStatus({
              appfolioSync: syncOption
            });
          }}
          loading={isPending}
        >
          Save
        </Button>
      </div>
    </Modal>
  );
};
